import { render, staticRenderFns } from "./kresz-park.vue?vue&type=template&id=8678e3e0&scoped=true&"
import script from "./kresz-park.vue?vue&type=script&lang=js&"
export * from "./kresz-park.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8678e3e0",
  null
  
)

export default component.exports